<ng-container [formGroup]="_form">
    <cmps-coaching-commitment-summary
        [commitmentDetailLabel]="_i18n._9832_COMMITMENT_SUMMARY | translate"
        [acceptAllActionLabel]="_i18n._9844_ACCEPT_ALL | translate"
        (acceptAllAction)="_onAcceptAllClick()"
        [commitmentNarrativeLabel]="
            _i18n._9487_COMMITMENT_NARRATIVE | translate
        "
        [modifiedElementLabel]="_i18n._9833_MODIFIED_ELEMENT | translate"
        [actionTakenLabel]="_i18n._9834_ACTION_TAKEN | translate"
        [userLabel]="_i18n._656_USER | translate"
        [sessionLabel]="_i18n._7310_SESSION_DATE | translate"
        [observationDetailsLabel]="_i18n._9835_LINKED_OBSERVATIONS | translate"
        [dateLabel]="_i18n._965_DATE | translate"
        [sessionTypeLabel]="_i18n._7309_SESSION_TYPE | translate"
        [goalDetailsLabel]="_i18n._7454_GOALS | translate"
        [previousGoalLabel]="_i18n._9796_PREVIOUS | translate"
        [newGoalLabel]="_i18n._9595_NEW | translate"
        [isShowNotes]="true"
        [isShowGoals]="true"
        [isShowObservation]="true"
        [keepEditingActionLabel]="_i18n._9837_KEEP_EDITING | translate"
        [sendApprovalActionLabel]="_i18n._9838_SEND_FOR_APPROVAL | translate"
        (sendApprovalAction)="
            _dialogRef.close({
                action: _CommitmentDetailDialogResultAction.SEND_FOR_APPROVAL
            })
        "
        [signOffActionLabel]="_i18n._9532_SIGN_OFF | translate"
        (signOffAction)="_onSignOffClick()"
        [receiverGotoCommitmentLabel]="_i18n._9840_GO_TO_COMMITMENT | translate"
        [receiverDisputeLabel]="_i18n._9472_DISPUTE | translate"
        (receiverDisputeAction)="_onDisputeClick()"
        [receiverAcceptAllSendLabel]="
            _i18n._9839_ACCEPT_ALL_AND_SEND | translate
        "
        (receiverAcceptAllSendAction)="_onSendAcceptAllClick()"
        [receiverDisputeCancelLabel]="_i18n._121_CANCEL | translate"
        [receiverDisputeSendLabel]="_i18n._9843_SEND | translate"
        [isReceiverDisputeSendDisabled]="_isSendDisabled"
        (receiverDisputeSendAction)="_onSendClick()"
        [isShowGotoCommitmentAction]="
            _options.summaryView ===
            _commitmentSummaryViewMode.COMMITMENT_UPDATED_RESULT_VIEW
        "
        [showSenderView]="
            _options.summaryView === _commitmentSummaryViewMode.SENDER_VIEW
        "
        [showReceiverView]="
            _options.summaryView === _commitmentSummaryViewMode.RECEIVER_VIEW
        "
        [showDisputeView]="
            _options.summaryView === _commitmentSummaryViewMode.DISPUTE_VIEW
        "
        [showActionButtons]="
            _options.summaryView === _commitmentSummaryViewMode.DISPUTE_VIEW
        "
        [showActionLabel]="
            _options.summaryView ===
            _commitmentSummaryViewMode.COMMITMENT_UPDATED_RESULT_VIEW
        "
    >
        <!-- todo make _form.get(i.diffItemContextId + '.approved').value a property accessor on the component -->
        <ng-template cmpsCoachingCommitmentSummaryNoteRows>
            <ng-container
                *ngFor="
                    let i of _options.data | diffItemFilter: _entityType.Note
                "
                [formGroupName]="i.diffItemContextId"
            >
                <cmps-coaching-commitment-summary-note-row
                    [modifiedElement]="i | cmpsDiffItemElementLabel"
                    [actionTaken]="i | cmpsDiffItemActionLabel"
                    [user]="_options?.from?.fullName"
                    [sessionDate]="
                        i?.context?.sessionDate | cmpsDate: 'LLL-dd-y'
                    "
                    [acceptActionLabel]="_i18n._120_ACCEPT | translate"
                    [isSelectedAcceptedButton]="
                        _form.get(i.diffItemContextId + '.approved').value
                    "
                    (acceptAction)="_onAcceptItemClick(i)"
                    [disputeActionLabel]="_i18n._9472_DISPUTE | translate"
                    [isSelectedDisputedButton]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                    (disputeAction)="_onDisputeItemClick(i)"
                    [actionResultLabel]="
                        (_form.get(i.diffItemContextId + '.approved').value
                            ? _i18n._9762_ACCEPTED
                            : _i18n._8703_DISPUTED
                        ) | translate
                    "
                    [showNote]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                >
                    <ng-template cmpsCoachingCommitmentSummaryNote>
                        <div
                            cmpsNoteDetailNext
                            formControlName="comment"
                        ></div>
                        <div
                            class="alert alert-warning"
                            role="alert"
                            *ngIf="
                                _form.get(i.diffItemContextId + '.comment')
                                    .dirty &&
                                _form.get(i.diffItemContextId + '.comment')
                                    .invalid
                            "
                        >
                            <span>
                                {{
                                    _i18n._9800_THE_TEXT_IS_REQUIRED | translate
                                }}
                            </span>
                        </div>
                    </ng-template>
                </cmps-coaching-commitment-summary-note-row>
            </ng-container>
        </ng-template>
        <ng-template cmpsCoachingCommitmentSummaryGoalRows>
            <ng-container
                *ngFor="
                    let i of _options.data | diffItemFilter: _entityType.Goal
                "
                [formGroupName]="i.diffItemContextId"
            >
                <cmps-coaching-commitment-summary-goal-row
                    [modifiedElement]="i | cmpsDiffItemElementLabel"
                    [actionTaken]="i | cmpsDiffItemActionLabel"
                    [previousGoal]="i | cmpsDiffItemActionValue: 'before'"
                    [newGoal]="i | cmpsDiffItemActionValue: 'after'"
                    [user]="_options?.from?.fullName"
                    [sessionDate]="
                        i?.context?.sessionDate | cmpsDate: 'LLL-dd-y'
                    "
                    [acceptActionLabel]="_i18n._120_ACCEPT | translate"
                    [isSelectedAcceptedButton]="
                        _form.get(i.diffItemContextId + '.approved').value
                    "
                    (acceptAction)="_onAcceptItemClick(i)"
                    [disputeActionLabel]="_i18n._9472_DISPUTE | translate"
                    [isSelectedDisputedButton]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                    (disputeAction)="_onDisputeItemClick(i)"
                    [actionResultLabel]="
                        (_form.get(i.diffItemContextId + '.approved').value
                            ? _i18n._9762_ACCEPTED
                            : _i18n._8703_DISPUTED
                        ) | translate
                    "
                    [showNote]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                >
                    <ng-template cmpsCoachingCommitmentSummaryNote>
                        <div
                            cmpsNoteDetailNext
                            formControlName="comment"
                        ></div>
                        <div
                            class="alert alert-warning"
                            role="alert"
                            *ngIf="
                                _form.get(i.diffItemContextId + '.comment')
                                    .dirty &&
                                _form.get(i.diffItemContextId + '.comment')
                                    .invalid
                            "
                        >
                            <span>
                                {{
                                    _i18n._9800_THE_TEXT_IS_REQUIRED | translate
                                }}
                            </span>
                        </div>
                    </ng-template>
                </cmps-coaching-commitment-summary-goal-row>
            </ng-container>
        </ng-template>

        <ng-template cmpsCoachingCommitmentSummaryObservationRows>
            <ng-container
                *ngFor="
                    let i of _options.data
                        | diffItemFilter: _entityType.CoachingEvent;
                    let index = index
                "
                [formGroupName]="i.diffItemContextId"
            >
                <cmps-coaching-commitment-summary-obs-row
                    [modifiedElement]="i | cmpsDiffItemElementLabel"
                    [actionTaken]="i | cmpsDiffItemActionLabel"
                    [date]="i?.context?.linkedOn | cmpsDate: 'LLL-dd-y'"
                    [sessionType]="i?.context?.deliveryTypeName"
                    [user]="_options?.from?.fullName"
                    [sessionDate]="
                        i?.context?.sessionDate | cmpsDate: 'LLL-dd-y'
                    "
                    [acceptActionLabel]="_i18n._120_ACCEPT | translate"
                    [isSelectedAcceptedButton]="
                        _form.get(i.diffItemContextId + '.approved').value
                    "
                    (acceptAction)="_onAcceptItemClick(i)"
                    [disputeActionLabel]="_i18n._9472_DISPUTE | translate"
                    [isSelectedDisputedButton]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                    (disputeAction)="_onDisputeItemClick(i)"
                    [actionResultLabel]="
                        (_form.get(i.diffItemContextId + '.approved').value
                            ? _i18n._9762_ACCEPTED
                            : _i18n._8703_DISPUTED
                        ) | translate
                    "
                    [showNote]="
                        _form.get(i.diffItemContextId + '.approved').value ===
                        false
                    "
                >
                    <ng-template cmpsCoachingCommitmentSummaryNote>
                        <div
                            cmpsNoteDetailNext
                            formControlName="comment"
                        ></div>
                        <div
                            class="alert alert-warning"
                            role="alert"
                            *ngIf="
                                _form.get(i.diffItemContextId + '.comment')
                                    .dirty &&
                                _form.get(i.diffItemContextId + '.comment')
                                    .invalid
                            "
                        >
                            <span>
                                {{
                                    _i18n._9800_THE_TEXT_IS_REQUIRED | translate
                                }}
                            </span>
                        </div>
                    </ng-template>
                </cmps-coaching-commitment-summary-obs-row>
            </ng-container>
        </ng-template>
    </cmps-coaching-commitment-summary>
</ng-container>
